import React from 'react'

import loadable from '@loadable/component'
import InsuranceIcon from '../components/project/icons/sidebar/InsuranceIcon'
import {
  addInsurerPath,
  addRolePath,
  addUserPath,
  bannerPath,
  benefitPath,
  completedTransactionPath,
  customerPath,
  dealerMasterPath,
  editInsurerPath,
  editRolePath,
  editUserPath,
  faqPath,
  forgotPasswordPath,
  insurerManagementPath,
  loginPath,
  pageContentPath,
  planManagementPath,
  popupPath,
  productPath,
  resetPasswordPath,
  rolePath,
  incompletedTransactionPath,
  userPath,
  commissionPath,
  commissionDetailPath,
  promotionPath,
  addPromotionPath,
  editPromotionPath
} from '../constants/route-name'
import CustomerIcon from '../components/project/icons/sidebar/CustomerIcon'
import DealerMasterIcon from '../components/project/icons/sidebar/DealerMasterIcon'
import UserIcon from '../components/project/icons/sidebar/UserIcon'
import RoleIcon from '../components/project/icons/sidebar/RoleIcon'
import ContentIcon from '../components/project/icons/sidebar/ContentIcon'
import { addInsurancePlanPath } from '../constants/route-name'
import { editInsurancePlanPath } from '../constants/route-name'
import { addCustomerPath } from '../constants/route-name'
import { editCustomerPath } from '../constants/route-name'
import { customerPurchaseDetailPath } from '../constants/route-name'
import { addDealerMasterPath } from '../constants/route-name'
import { dealerMasterPurchaseDetailPath } from '../constants/route-name'
import { editDealerMasterPath } from '../constants/route-name'
import { bannerDetailPath } from '../constants/route-name'
import { editPageContentPath } from '../constants/route-name'
import { transactionPath } from '../constants/route-name'
import { addTransactionPath } from '../constants/route-name'
import { transactionDetailPath } from '../constants/route-name'
import TransactionIcon from '../components/project/icons/sidebar/TransactionIcon'
import { PERMISSIONS } from '../constants/permissions'
import PromotionIcon from '../components/project/icons/sidebar/PromotionIcon'

// Auth
const LoginPage = loadable(() => import('../pages/auth/LoginPage'))
const ResetPasswordPage = loadable(() => import('../pages/auth/ResetPasswordPage'))
const ForgotPasswordPage = loadable(() => import('../pages/auth/ForgotPasswordPage'))

// HomePage
const HomePage = loadable(() => import('../pages/HomePage'))

// Insurer
const InsurerManagementPage = loadable(() => import('../pages/insurance/InsurerManagementPage'))
const AddInsurerPage = loadable(() => import('../pages/insurance/AddInsurerPage'))
const EditInsurerPage = loadable(() => import('../pages/insurance/EditInsurerPage'))
// Plan
const PlanManagementPage = loadable(() => import('../pages/insurance/PlanManagementPage'))
const AddInsurancePlanPage = loadable(() => import('../pages/insurance/AddInsurancePlanPage'))
const EditInsurancePlanPage = loadable(() => import('../pages/insurance/EditInsurancePlanPage'))

// Customer
const CustomerPage = loadable(() => import('../pages/customer/CustomerPage'))
const AddCustomerPage = loadable(() => import('../pages/customer/AddCustomerPage'))
const EditCustomerPage = loadable(() => import('../pages/customer/EditCustomerPage'))
const CustomerPurchaseDetailPage = loadable(() => import('../pages/customer/CustomerPurchaseDetailPage'))

// Dealer Master
const DealerMasterPage = loadable(() => import('../pages/dealer-master/DealerMasterPage'))
const AddDealerMasterPage = loadable(() => import('../pages/dealer-master/AddDealerMasterPage'))
const EditDealerMasterPage = loadable(() => import('../pages/dealer-master/EditDealerMasterPage'))
const DealerMasterPurchaseDetailPage = loadable(() => import('../pages/dealer-master/DealerMasterPurchaseDetailPage'))
//Commission
const CommissionPage = loadable(() => import('../pages/dealer-master/CommissionPage'))
const CommissionDetailPage = loadable(() => import('../pages/dealer-master/CommissionDetailPage'))

//User
const UserPage = loadable(() => import('../pages/user/UserPage'))
const AddUserPage = loadable(() => import('../pages/user/user/AddUserPage'))
const EditUserPage = loadable(() => import('../pages/user/user/EditUserPage'))

const RolePage = loadable(() => import('../pages/user/RolePage'))
const AddRolePage = loadable(() => import('../pages/user/role/AddRolePage'))
const EditRolePage = loadable(() => import('../pages/user/role/EditRolePage'))

//Banner
const BannerPage = loadable(() => import('../pages/content/BannerPage'))
const BannerDetailPage = loadable(() => import('../pages/content/BannerDetailPage'))
//Popup
const PopupPage = loadable(() => import('../pages/content/PopupPage'))
//Page
const PageContentPage = loadable(() => import('../pages/content/PageContentPage'))
const EditPageContentPage = loadable(() => import('../pages/content/EditPageContentPage'))
//Product
const ProductPage = loadable(() => import('../pages/content/ProductPage'))
//Benefit
const BenefitPage = loadable(() => import('../pages/content/BenefitPage'))
//FAQ
const FaqPage = loadable(() => import('../pages/content/FaqPage'))

//Transaction
const TransactionPage = loadable(() => import('../pages/transaction/TransactionPage'))
const AddTransactionPage = loadable(() => import('../pages/transaction/AddTransactionPage'))
const TransactionDetailPage = loadable(() => import('../pages/transaction/TransactionDetailPage'))

//Promotion
const PromotionPage = loadable(() => import('../pages/promotion/PromotionPage'))
const AddPromotionPage = loadable(() => import('../pages/promotion/AddPromotionPage'))
const EditPromotionPage = loadable(() => import('../pages/promotion/EditPromotionPage'))

export const RENDER_SIDEBAR_ROUTES = [
  {
    title: 'Insurance',
    icon: <InsuranceIcon />,
    permissions: [PERMISSIONS.insurerManagement, PERMISSIONS.planManagement],
    child: [
      { title: 'Insurer Management', path: insurerManagementPath, permissions: PERMISSIONS.insurerManagement },
      { title: 'Plan Management', path: planManagementPath, permissions: PERMISSIONS.planManagement }
    ]
  },
  {
    title: 'Transactions',
    icon: <TransactionIcon />,
    permissions: [PERMISSIONS.transaction],
    child: [
      { title: 'All', path: transactionPath, permissions: PERMISSIONS.transaction },
      { title: 'Completed', path: completedTransactionPath, permissions: PERMISSIONS.transaction },
      { title: 'Incompleted', path: incompletedTransactionPath, permissions: PERMISSIONS.transaction }
    ]
  },
  {
    title: 'Customer',
    icon: <CustomerIcon />,
    path: customerPath,
    permissions: [PERMISSIONS.customer]
  },
  {
    title: 'Dealer Master',
    icon: <DealerMasterIcon />,
    permissions: [PERMISSIONS.dealerMaster],
    child: [
      { title: 'Dealer Master', path: dealerMasterPath, permissions: PERMISSIONS.dealerMaster },
      { title: 'Commission', path: commissionPath, permissions: PERMISSIONS.dealerMaster }
    ]
  },
  {
    title: 'Role Management',
    icon: <RoleIcon />,
    path: rolePath,
    permissions: [PERMISSIONS.roleManagement]
  },
  {
    title: 'User Management',
    icon: <UserIcon />,
    path: userPath,
    permissions: [PERMISSIONS.userManagement]
  },

  {
    title: 'Content',
    icon: <ContentIcon />,
    permissions: [
      PERMISSIONS.banner,
      PERMISSIONS.popup,
      PERMISSIONS.page,
      PERMISSIONS.products,
      PERMISSIONS.benefit,
      PERMISSIONS.faq
    ],
    child: [
      { title: 'Banner', path: bannerPath, permissions: PERMISSIONS.banner },
      { title: 'Pop-up', path: popupPath, permissions: PERMISSIONS.popup },
      { title: 'Pages', path: pageContentPath, permissions: PERMISSIONS.page },
      { title: 'Products', path: productPath, permissions: PERMISSIONS.products },
      { title: 'Benefit', path: benefitPath, permissions: PERMISSIONS.benefit },
      { title: 'FAQ', path: faqPath, permissions: PERMISSIONS.faq }
    ]
  },
  {
    title: 'Promotion',
    icon: <PromotionIcon />,
    path: promotionPath,
    permissions: [PERMISSIONS.dealerMaster]
  }
]

const authRoutes = [
  {
    path: loginPath,
    component: <LoginPage />
  },
  {
    path: forgotPasswordPath,
    component: <ForgotPasswordPage />
  },
  {
    path: resetPasswordPath,
    component: <ResetPasswordPage />
  }
]

const insurerRoutes = [
  {
    path: insurerManagementPath,
    component: <InsurerManagementPage />,
    permissions: PERMISSIONS.insurerManagement
  },
  {
    path: addInsurerPath,
    component: <AddInsurerPage />,
    permissions: PERMISSIONS.insurerManagement
  },
  {
    path: editInsurerPath(':insurerId'),
    component: <EditInsurerPage />,
    permissions: PERMISSIONS.insurerManagement
  }
]
const planRoutes = [
  {
    path: planManagementPath,
    component: <PlanManagementPage />,
    permissions: PERMISSIONS.planManagement
  },
  {
    path: addInsurancePlanPath,
    component: <AddInsurancePlanPage />,
    permissions: PERMISSIONS.planManagement
  },
  {
    path: editInsurancePlanPath(':planId'),
    component: <EditInsurancePlanPage />,
    permissions: PERMISSIONS.planManagement
  }
]
const customerRoutes = [
  {
    path: customerPath,
    component: <CustomerPage />,
    permissions: PERMISSIONS.customer
  },
  {
    path: addCustomerPath,
    component: <AddCustomerPage />,
    permissions: PERMISSIONS.customer
  },
  {
    path: editCustomerPath(':customerId'),
    component: <EditCustomerPage />,
    permissions: PERMISSIONS.customer
  },
  {
    path: customerPurchaseDetailPath(':customerId', ':transactionId'),
    component: <CustomerPurchaseDetailPage />,
    permissions: PERMISSIONS.customer
  }
]
const dealerMasterRoutes = [
  {
    path: dealerMasterPath,
    component: <DealerMasterPage />,
    permissions: PERMISSIONS.dealerMaster
  },
  {
    path: addDealerMasterPath,
    component: <AddDealerMasterPage />,
    permissions: PERMISSIONS.dealerMaster
  },
  {
    path: editDealerMasterPath(':dealerId'),
    component: <EditDealerMasterPage />,
    permissions: PERMISSIONS.dealerMaster
  },
  {
    path: dealerMasterPurchaseDetailPath(':dealerId', ':transactionId'),
    component: <DealerMasterPurchaseDetailPage />,
    permissions: PERMISSIONS.dealerMaster
  },
  {
    path: commissionPath,
    component: <CommissionPage />,
    permissions: PERMISSIONS.dealerMaster
  },
  {
    path: commissionDetailPath(':dealerId'),
    component: <CommissionDetailPage />,
    permissions: PERMISSIONS.dealerMaster
  }
]
const userRoutes = [
  {
    path: userPath,
    component: <UserPage />,
    permissions: PERMISSIONS.userManagement
  },
  {
    path: addUserPath,
    component: <AddUserPage />,
    permissions: PERMISSIONS.userManagement
  },
  {
    path: editUserPath(':userId'),
    component: <EditUserPage />,
    permissions: PERMISSIONS.userManagement
  },
  {
    path: rolePath,
    component: <RolePage />,
    permissions: PERMISSIONS.roleManagement
  },
  {
    path: addRolePath,
    component: <AddRolePage />,
    permissions: PERMISSIONS.roleManagement
  },
  {
    path: editRolePath(':roleId'),
    component: <EditRolePage />,
    permissions: PERMISSIONS.roleManagement
  }
]
const contentRoutes = [
  {
    path: bannerPath,
    component: <BannerPage />,
    permissions: PERMISSIONS.banner
  },
  {
    path: bannerDetailPath(':positionId'),
    component: <BannerDetailPage />,
    permissions: PERMISSIONS.banner
  },
  {
    path: popupPath,
    component: <PopupPage />,
    permissions: PERMISSIONS.popup
  },
  {
    path: pageContentPath,
    component: <PageContentPage />,
    permissions: PERMISSIONS.page
  },
  {
    path: editPageContentPath(':pageId'),
    component: <EditPageContentPage />,
    permissions: PERMISSIONS.page
  },
  {
    path: productPath,
    component: <ProductPage />,
    permissions: PERMISSIONS.products
  },
  {
    path: benefitPath,
    component: <BenefitPage />,
    permissions: PERMISSIONS.benefit
  },
  {
    path: faqPath,
    component: <FaqPage />,
    permissions: PERMISSIONS.faq
  }
]
const transactionRoutes = [
  {
    path: transactionPath,
    component: <TransactionPage />,
    permissions: PERMISSIONS.transaction
  },
  {
    path: completedTransactionPath,
    component: <TransactionPage />,
    permissions: PERMISSIONS.transaction
  },
  {
    path: incompletedTransactionPath,
    component: <TransactionPage />,
    permissions: PERMISSIONS.transaction
  },
  {
    path: addTransactionPath,
    component: <AddTransactionPage />,
    permissions: PERMISSIONS.transaction
  },
  {
    path: transactionDetailPath(':transactionId'),
    component: <TransactionDetailPage />,
    permissions: PERMISSIONS.transaction
  }
]
const promotionRoutes = [
  {
    path: promotionPath,
    component: <PromotionPage />,
    permissions: PERMISSIONS.dealerMaster
  },
  {
    path: addPromotionPath,
    component: <AddPromotionPage />,
    permissions: PERMISSIONS.dealerMaster
  },
  {
    path: editPromotionPath(':promotionId'),
    component: <EditPromotionPage />,
    permissions: PERMISSIONS.dealerMaster
  }
]

export const RENDER_UNPROTECTED_ROUTES = [...authRoutes]
export const RENDER_PROTECTED_ROUTES = [
  {
    path: '/home',
    component: <HomePage />,
    permissions: ''
  },
  ...insurerRoutes,
  ...planRoutes,
  ...customerRoutes,
  ...dealerMasterRoutes,
  ...userRoutes,
  ...contentRoutes,
  ...transactionRoutes,
  ...promotionRoutes
]
